import { Validator } from '@vista-digital/validator';
/*
 * Positioning options for the seating screen.
 */
export var OccSeatingScreenPosition;
(function (OccSeatingScreenPosition) {
    OccSeatingScreenPosition["Top"] = "Top";
    OccSeatingScreenPosition["Bottom"] = "Bottom";
})(OccSeatingScreenPosition || (OccSeatingScreenPosition = {}));
export const occSeatingScreenPositionValidator = Validator.oneOf(Object.values(OccSeatingScreenPosition));
//# sourceMappingURL=screen-position.js.map